<template>
  <div>
    <base-card class="rounded-lg pb-2">
      <div
        class="d-flex justify-center text--disabled align-center gap-1 pt-1 unselectable"
      >
        <small class="lh-1">Controle de Caixa</small>
      </div>
      <v-tabs v-model="tab" show-arrows class="rounded-lg" height="36px">
        <v-tab
          v-for="item in tabs"
          :key="item.id"
          class="rounded-lg"
        >
          <v-icon left small>{{ item.icon }}</v-icon>
          {{ item.name }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item
          v-for="item in tabs"
          :key="item.id"
          class="pa-4"
        >
          <component :is="item.component" />
        </v-tab-item>
      </v-tabs-items>
    </base-card>

    <v-bottom-sheet
      v-model="navigationSheet"
      inset
      max-width="550px"
      :overlay-opacity="0.8"
      content-class="elevation-0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          fab
          dark
          style="position: fixed; bottom: 76px; right: 16px; z-index: 5"
          float
          v-bind="attrs"
          v-on="on"
          color="primary"
        >
          <v-icon>mdi-dots-grid</v-icon>
        </v-btn>
      </template>
      <div class="mb-4 px-4 d-flex w-full">
        <v-card class="pa-3 pb-1 rounded-lg w-full">
          <v-row dense class="mx-0">
            <v-col
              v-for="item in tabs"
              :key="item.id"
              cols="4"
              sm="4"
              md="3"
            >
              <v-card
                @click="selectTab(item.id)"
                outlined
                height="90px"
                elevation="0"
                class="pa-2"
              >
                <div
                  class="d-flex align-center justify-center flex-column h-full text-center lh-1 gap-2"
                >
                  <v-icon>{{ item.icon }}</v-icon>
                  {{ item.name }}
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div class="d-flex justify-center">
            <v-btn @click="navigationSheet = false" text small>Fechar</v-btn>
          </div>
        </v-card>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
import CashSummary from "@/components/ultimate/cash/CashSummary.vue";
import CashEntries from "@/components/ultimate/cash/CashEntries.vue";
import CashDre from "@/components/ultimate/cash/CashDre.vue";
import CashCategories from "@/components/ultimate/cash/CashCategories.vue";

export default {
  metaInfo: {
    title: "Controle de Caixa",
  },
  components: {
    CashSummary,
    CashEntries,
    CashDre,
    CashCategories,
  },
  data() {
    return {
      tab: 0,
      navigationSheet: false,
      tabs: [
        {
          id: "summary",
          name: "Resumo",
          component: "CashSummary",
          icon: "mdi-chart-box-outline",
        },
        {
          id: "entries",
          name: "Lançamentos",
          component: "CashEntries",
          icon: "mdi-cash-register",
        },
        {
          id: "dre",
          name: "DRE",
          component: "CashDre",
          icon: "mdi-file-chart-outline",
        },
        {
          id: "categories",
          name: "Categorias",
          component: "CashCategories",
          icon: "mdi-shape-outline",
        },
      ],
    };
  },
  methods: {
    selectTab(id) {
      const index = this.tabs.findIndex((tab) => tab.id === id);
      if (index >= 0) this.tab = index;
      this.navigationSheet = false;
    },
    openTabFromQuery() {
      const tabId = this.$route.query.tab || (this.$route.query.entryId ? "entries" : null);
      if (!tabId) return;
      this.selectTab(tabId);
    },
  },
  mounted() {
    this.openTabFromQuery();
  },
};
</script>
